/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Avatar_HintInputs */

const en_settings_profile_avatar_hint = /** @type {(inputs: Settings_Profile_Avatar_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop an image, click to upload, or paste from clipboard`)
};

/**
* | output |
* | --- |
* | "Drop an image, click to upload, or paste from clipboard" |
*
* @param {Settings_Profile_Avatar_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_profile_avatar_hint = /** @type {((inputs?: Settings_Profile_Avatar_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Avatar_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_profile_avatar_hint(inputs)
});
export { settings_profile_avatar_hint as "settings.profile.avatar_hint" }